<template>
<div class="welcome">
  <div>
    <img v-if="logo !== null" :src="logo" alt="logo" class="logo" />
    <div v-if="!isOpen" v-html="closedText"></div>
    <div v-else v-html="welcomeText"></div>
  </div>
  <div class="buttons">
    <v-btn
      v-if="isOpen"
      class="submit-button"
      color="primary"
      @click="$emit('continue')">
      {{ continueButton }}
    </v-btn>
  </div>
</div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Welcome',
  computed: {
    ...mapState([
      'logo',
      'welcomeText',
      'continueButton',
      'agreementText',
      'closedText',
    ]),
    isOpen() {
      return this.agreementText !== null;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/_variables.scss";

.welcome {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100%;
  padding: 1.5rem 1.5rem 1.5rem 1.5rem;

  .logo {
    display: block;
    max-width: 300px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 2rem;
  }

  .buttons {
    display: flex;
    width: 100%;
    flex-direction: row-reverse;
    justify-content: space-between;
    align-self: center;
  }
}

@media (min-width: $breakpoint-tablet) {
  .welcome {
    justify-content: flex-start;

    .buttons {
      margin-top: 3rem;
    }
  }
}
</style>
